<template>
  <el-row>
    <!-- SI selection -->
    <!-- <el-col :span="24" :md="12">
      <el-select v-model="si" filterable
        placeholder="(搜尋經銷商)" @change="onSiSelected">
        <el-option v-for="option in sis" :key="option.id"
          :label="option.name" :value="option.id">
        </el-option>
      </el-select>
    </el-col> -->

    <!-- Shop selection -->
    <!-- <el-col :span="24" :md="12">
      <el-select v-model="shop" filterable
        placeholder="(搜尋店家)" @change="onShopSelected">
        <el-option v-for="option in filteredShops" :key="option.id"
          :label="option.name" :value="option.id">
        </el-option>
      </el-select>
    </el-col> -->

    <el-form :inline="true" label-position="top">
      <el-form-item :label="$t('ShopFinder.Distributor')" v-if="!shopsOnly && userType === 'gaa'">
        <el-select v-model="si" clearable filterable
          :placeholder="`(${$t('ShopFinder.Search_Distributor')})`" @change="onSiSelected">
          <el-option v-for="option in sis" :key="option.id"
            :label="option.name" :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('ShopFinder.Store')" v-if="userType !== 'eaa'">
        <el-select v-model="shop" clearable filterable remote reserve-keyword :placeholder="`(${$t('ShopFinder.Search_Store')})`"
          @change="onShopSelected"
          :remote-method="fetchListOfShops" :loading="select.shops.loading">
          <el-option v-for="option in filteredShops" :key="option.id"
            :label="option.name" :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('ShopFinder.Store')" v-if="userType === 'eaa'">
        <el-select v-model="shop" clearable filterable :placeholder="`(${$t('ShopFinder.Search_Store')})`"
          @change="onShopSelected">
          <el-option v-for="option in filteredShops" :key="option.id"
            :label="option.name" :value="option.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

  </el-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ShopFinder',
  components: [

  ],
  props: {
    shopsOnly: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    if (this.userType === 'gaa') {
      this.fetchListOfSis();
      // this.fetchListOfShops();
    }
    else if (this.userType === 'si') {
      this.si = this.user.id;//So that the shop list should only includes shops of this SI.
      // this.fetchListOfShops();
    }
    else if (this.userType === 'eaa') {
      this.fetchListOfShops();
    }
  },

  methods: {
    fetchListOfSis() {
      axios
      .get(`${process.env.VUE_APP_APIHOST}/${this.userType}/si-accounts`)
      .then(response => {
        console.log(`[ShopFinder] SIs`, response.data);
        this.sis = response.data;
      })
      .catch(err => {
        console.error(`[ShopFinder] Cannot fetch SI list`, err);
      });
    },

    fetchListOfShops(keyword) {
      if (keyword !== undefined && !keyword.length) return;
      this.select.shops.loading = true;

      axios.get(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/shops`
        + (keyword? `?keyword=${keyword}`: '')
      )
      .then(response => {
        console.log(`[ShopFinder] fetchListOfShops`, response.data);

        if (this.userType !== 'eaa') {//Cause EAA's get-shops response is differently structured.
          this.shops = response.data;
        }
        else if (Array.isArray(response.data.shops)) {
          this.shops = [ ];
          response.data.shops.forEach(shop => {
            this.shops.push({ id: shop['accountId'], name: shop['name'] });
          });
        }
        else {
          throw new Error(`Cannot resolve response data of shop list.`);
        }
        
      })
      .catch(err => {
        console.error(`[ShopFinder] Cannot fetch shop list`, err);
      })
      .finally(() => {
        this.select.shops.loading = false;
      });
    },

    onSiSelected(siId) {
      console.log(`[ShopFinder] on SI selected`, siId);
      // Whenever SI selection changed, reset shop selector.
      this.shop = null;
      this.$emit('si-selected', siId);
    },
    onShopSelected(shopId) {
      console.log(`[ShopFinder] on shop selected`, shopId);
      this.$emit('shop-selected', shopId, this.selectedShopName);
    }
  },

  data() {
    return {
      si: null,
      eaa: null,
      shop: null,

      sis: [ ],
      shops: [ ],

      select: {
        shops: {
          loading: false
        }
      }
    };
  },

  computed: {
    filteredShops() {
      return this.shops.filter(shop => {
        if (this.si)
          return shop.siId === this.si;
        return true;
      });
    },

    selectedShopName() {
      let ret = this.shops.find(shop => {
        return shop.id === this.shop;
      });
      if (ret) return ret.name;
      return null;
    },

    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    }
  }

}
</script>